import Joi from "@hapi/joi";

export default {
    username: {
        fieldName: "username",
        defaultValue: "",
        validation: Joi.string()
            .required()
            .label("Username"),
        render: {
            type: "input",
            configuration: {
                label: "Username",
                autofocus: true
            }
        }
    },
    password: {
        defaultValue: "",
        validation: Joi.string()
            .required()
            .label("Password"),
        render: {
            type: "input",
            configuration: {
                type: "password",
                label: "Password",
                help: "Password is case-sensitive"
            }
        }
    },
    company: {
        name: {
            defaultValue: "",
            validation: Joi.string()
                .label("Firmenname"),
            render: {
                type: "input",
                configuration: {
                    label: "Firmenname"
                }
            }
        },
        contactPersons: {
            defaultValue: [],
            validation: Joi.any(),
            // .required()
            // .label("Fahrzeug"),
            render: {
                type: "detailTable1",
            },
            baseInformation: {
                firstname: {
                    defaultValue: "",
                    validation: Joi.string()
                        .required()
                        .label("Vorname"),
                    render: {
                        type: "input",
                        configuration:
                            {
                                label: "Vorname"
                            }
                    }
                },
                surname: {
                    defaultValue: "",
                    validation: Joi.string()
                        .required()
                        .label("Nachname"),
                    render: {
                        type: "input",
                        configuration: {
                            label: "Nachname"
                        }
                    }
                },
                mobileNumber: {
                    defaultValue: "",
                    validation: Joi.string()
                        .required()
                        .label("Mobilnummer"),
                    render: {
                        type: "input",
                        configuration: {
                            label: "Mobilnummer"
                        }
                    }
                },
                email: {
                    defaultValue: "",
                    validation: Joi.string()
                        .required()
                        .label("Email"),
                    render: {
                        type: "input",
                        configuration: {
                            label: "Email"
                        }
                    }
                }
            }

        }
    }
}
